/* istanbul ignore file */
/* eslint-disable react/prop-types */
import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import DeviceDetailsTable from '../../devices/DeviceDetailsPage/DeviceDetailsTable';
import DeviceDetailsHeader from '../../devices/DeviceDetailsPage/DeviceDetailsHeader/DeviceDetailsHeader';
import DeviceSensors from '../../devices/DeviceDetailsPage/DeviceSensorsDashboard/DeviceSensors/DeviceSensors';
import MaxDeviceSensors from '../../devices/DeviceDetailsPage/DeviceSensorsDashboard/MaxDeviceSensors/MaxDeviceSensors';
import { deviceDataPropTypes } from '../../devices/DeviceDetailsPage/DeviceDetailsPropTypes';

function PublicDeviceDetailsLayout({ device }) {
  const deviceData = device && device.data;
  const location = useLocation();
  const deviceLatestFirmware = location.state ? location.state.latestFirmware : null;

  const saveDeviceName = () => {
  };

  if (!device || !deviceData) {
    // todo: get public redirect url
    return (
      <Redirect to="/p/" />
    );
  }
  if (device && deviceData && deviceData.general) {
    if (device && deviceData.general && deviceData.general.type) {
      if (!deviceData.general.type.startsWith('RA')) {
        window.location.href = `/public/device/${deviceData.general.publicPageHash}`;
        return null;
      }
    }
  }

  return (
    <>
      <DeviceDetailsHeader
        deviceInfo={deviceData.general}
        handleSubmitNameChange={saveDeviceName}
        isPublic
      />
      {/* Main Device Info Section */}
      <div className="row">
        <DeviceDetailsTable
          deviceInfo={deviceData.general}
          latestFirmware={deviceLatestFirmware}
                    /* istanbul ignore next */
          // deviceImage={getDeviceImage(device.general.type)}
          deviceImage=""
          isReadOnly
        />
      </div>

      {deviceData.general.type === 'RAMAX'
        ? (
          <MaxDeviceSensors
            sensors={deviceData.sensors}
            deviceInfo={deviceData.general}
            isReadOnly
          />
        )
        : (
          <DeviceSensors
            sensors={deviceData.sensors}
            deviceInfo={deviceData.general}
            isReadOnly
          />
        )}
    </>
  );
}

PublicDeviceDetailsLayout.propTypes = {
  device: deviceDataPropTypes.isRequired,
};

export default PublicDeviceDetailsLayout;
